module.exports = __webpack_public_path__ + "media/images/niq-merge-0eee58f73a005d1d4671c905ca1d7094.png";